module.exports = __webpack_public_path__ + "static/media/map-marker-minus.10e139af.svg";